import experiments from '@reverbdotcom/commons/src/experiments';
import { CoreMarketplaceCombinedMarketplaceSearch } from '../../schemas/rql';

export const ALWAYS_TRACKED_EXPERIMENTS = [
  experiments.LISTING_CARD_LOCATION,
  experiments.DUMMY,
  experiments.MARKETPLACE_GRID_ADS,
  experiments.LISTINGS_QUERY_REWRITE_V2,
  experiments.LISTINGS_SEARCH_BEST_MATCH_SIGNALS_V3,
  experiments.LTS_V3_MARKETPLACE,
  experiments.AA_MARKETPLACE_SESSION_BUCKETING,
  experiments.PRICE_DROP_FILTER,
  experiments.MARKETPLACE_QUERY_SUGGESTIONS,
];

export function pageViewTrackedExperiments(_listingsSearchResult: CoreMarketplaceCombinedMarketplaceSearch.ListingsSearch): string[] {
  return [].concat(ALWAYS_TRACKED_EXPERIMENTS);
}
